import React, { useRef, useState } from "react";
import "./Footer.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  Slider,
  Checkbox,
  Dropdown_aspect,
  ColorPicker,
  NumberInput,
} from "../../../Components/";
import { useSelector, useDispatch } from "react-redux";
import {
  updateSettingOptionState,
  saveProjectSettings,
  updateProjectCreditsByGoogle,
  updateProjectCredits,
} from "../../../Redux/actions/projectActions";
import CloneProjectModal from "../CloneProject/CloneProjectModal";
import { ASPECT_FRAME_OPTIONS } from "../Preview/previewPlaybackUtils";
import Render from "../Render/Render";
import RenderNew from "../Render/RenderNew";
import {
  selectedPageOption,
  setGlobalColorInReudx,
} from "../../../Redux/actions/commonActtion";
import CardRender from "../Cards/CardRender";
import { AiOutlineGlobal } from "react-icons/ai";
import { FiImage, FiX } from "react-icons/fi";
import CustomToast, {
  customToatStyle,
  customToatStyleError,
} from "../../../Components/CustomToast/CustomToast";
import { read, utils } from "xlsx";
import { excelDataToCredits } from "../../../services/excelDataToProjectData";
import { CreditBtnIcon, SyncNav } from "../../../assets/icons";
import { useLocation, useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import {
  DEFAULT_MATTE_COLOR,
  TRANSPARENT_MATTE_COLOR,
  isTransparentMatte,
} from "../utils/projectBackground";
const debounceTimeoutIds = {};

const fileToBackgroundDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Failed to read image"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Failed to load image"));
      img.onload = () => {
        const maxW = 1920;
        const scale = Math.min(1, maxW / Math.max(img.width, 1));
        const w = Math.max(1, Math.round(img.width * scale));
        const h = Math.max(1, Math.round(img.height * scale));
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL("image/jpeg", 0.82));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });

const getUpdatedProjectCredits = (currentCredits, newCredits) => {
  try {
    const updatedCredits = newCredits;
    for (let i = 0; i < newCredits.length; i++) {
      let idx = currentCredits.findIndex(
        (credit) =>
          credit.options.block_name == newCredits[i].options.block_name,
      );
      if (
        idx !== -1 &&
        currentCredits[idx].options.block_type ==
          newCredits[i].options.block_type
      ) {
        updatedCredits[i].options = currentCredits[idx].options;
      }
    }
    return { data: updatedCredits };
  } catch (error) {
    return { error, data: null };
  }
};

const Footer = ({
  currentBlockOptions,
  isTitleSafe,
  setIsTitleSafe,
  getBlockSize,
  aspectRatio_FrameSize,
  setAspectRatio_FrameSize,
  handleFooterClick,
  isCard,
  setIsDisplayTitle,
  isDisplayTitle,
  isRenderExport,
  setIsRenderExport,
  setReLoading,
}) => {
  // console.log('currentBlockOptions  = ',currentBlockOptions?.text_alignment==='gutter' || currentBlockOptions?.text_alignment==='ragged'
  // )
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  let { isDashboard } = location?.state;
  // console.log('Footer location = ',isDashboard ,location);

  const [selectedID, setSelectedID] = useState("");
  const {
    googleSheetLink,
    _id,
    googleSpreadSheetId,
    credits: currentCredits,
    currentBlock,
  } = useSelector((state) => state?.project);
  const projectSettings = useSelector((state) => state.project.settings);

  const [renderOpen, setRenderOpen] = useState(false);
  const [projectCloneModalOpen, setProjectCloneModalOpen] = useState(false);
  const options = ASPECT_FRAME_OPTIONS;

  const { gobalBGcolor } = useSelector((state) => state?.commonReducer);
  // Background color + image controls
  const bgFileRef = useRef(null);
  const [isBgUploading, setIsBgUploading] = useState(false);
  const storedMatte = projectSettings?.matte_color;
  const matteIsTransparent = isTransparentMatte(storedMatte);
  const matteColor = matteIsTransparent
    ? TRANSPARENT_MATTE_COLOR
    : storedMatte || gobalBGcolor || DEFAULT_MATTE_COLOR;
  const backgroundImage = projectSettings?.background_image || "";
  const updateProjectSettingsState = (key, value) =>
    dispatch(updateSettingOptionState(key, value));
  const saveProjectSettingsCall = () => dispatch(saveProjectSettings());
  const debouncedSettingsSave = debounce(saveProjectSettingsCall, 1000);
  const debouncedSave = (key, value) => {
    if (debounceTimeoutIds[key]) {
      clearTimeout(debounceTimeoutIds[key]);
      debounceTimeoutIds[key] = null;
    }
    debounceTimeoutIds[key] = setTimeout(() => {
      saveProjectSettingsCall(key, value);
    }, 1500);
  };

  const handleMatteColorChange = (val) => {
    updateProjectSettingsState("matte_color", val);
    dispatch(setGlobalColorInReudx(val));
    debouncedSave("matte_color", val);
  };

  const clearMatteColor = () => {
    updateProjectSettingsState("matte_color", TRANSPARENT_MATTE_COLOR);
    dispatch(setGlobalColorInReudx(TRANSPARENT_MATTE_COLOR));
    saveProjectSettingsCall();
  };

  const handleBackgroundImagePick = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast(
        <CustomToast
          isError
          title="Invalid file"
          content="Please choose an image file (PNG, JPG, or WebP)."
        />,
        customToatStyleError,
      );
      return;
    }
    try {
      setIsBgUploading(true);
      const dataUrl = await fileToBackgroundDataUrl(file);
      updateProjectSettingsState("background_image", dataUrl);
      await saveProjectSettingsCall();
    } catch (err) {
      toast(
        <CustomToast
          isError
          title="Upload failed"
          content="Could not process that background image."
        />,
        customToatStyleError,
      );
    } finally {
      setIsBgUploading(false);
    }
  };

  const clearBackgroundImage = async () => {
    updateProjectSettingsState("background_image", "");
    await saveProjectSettingsCall();
  };

  const handleGoogleUpdate = async () => {
    await setReLoading({ condn: true, label: "Syncing..." });

    try {
      const res = await dispatch(
        updateProjectCreditsByGoogle(
          _id,
          googleSpreadSheetId,
          currentCredits,
          isCard,
        ),
      );
      if (res?.success === true) {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast title="" content={res?.message} />,
            customToatStyle,
          );
        }, 300);
      } else {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast
              isError
              title={res?.response?.data?.title || "Error"}
              content={res?.response?.data?.message}
            />,
            customToatStyleError,
          );
        }, 2000);
      }
    } catch (err) {
      await setReLoading({ condn: false, label: "" });
    }
  };

  const handleFileInput = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const binaryStr = evt.target.result;
        const wb = read(binaryStr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = utils.sheet_to_json(ws, { header: 1 });
        const newCredits = excelDataToCredits(jsonData);
        const { data: updatedCredits, error } = getUpdatedProjectCredits(
          currentCredits,
          newCredits,
        );
        if (error) {
          return error;
        }
        dispatch(updateProjectCredits(_id, updatedCredits));
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      return err;
    }
  };

  const OptionHandler = (val) => {
    dispatch(selectedPageOption(val, _id, isCard));
    navigate("", {
      state: {
        isDashboard: isDashboard,
        isRender: true,
        projectId: _id,
        isCard: isCard ? isCard : false,
      },
      replace: true,
    });
  };

  // Footer gutter controls: ragged → Ragged Gutter; otherwise Gutter when the
  // live layout actually pads with settings.gutter (Role+Name double-column
  // left/right/justify/gutter/center, or nameonly/song gutter alignment).
  const textAlign = currentBlockOptions?.text_alignment;
  const showRaggedGutter = textAlign === "ragged";
  const showGutter =
    !showRaggedGutter &&
    (textAlign === "center" ||
      textAlign === "gutter" ||
      // Role+Name double-column left/right/justify pad with settings.gutter
      (currentBlockOptions?.double_columns &&
        (textAlign === "left" ||
          textAlign === "right" ||
          textAlign === "justify")));

  return (
    <>
      <div className="main-footer">
        <div className="centerBottom">
          {showRaggedGutter ? (
            <div className="">
              <Slider
                RaggedGutter={projectSettings?.ragged_gutter}
                label={"Ragged Gutter"}
                value={projectSettings?.ragged_gutter}
                handleChange={(val) => {
                  updateProjectSettingsState("ragged_gutter", val);
                  debouncedSave();
                }}
                min={0}
                max={15}
                step={1}
              />
            </div>
          ) : showGutter ? (
            <div className="w-[25%]">
              <Slider
                gutter={projectSettings?.gutter}
                label={"Gutter"}
                value={projectSettings?.gutter}
                handleChange={(val) => {
                  updateProjectSettingsState("gutter", val);
                  debouncedSave();
                }}
                min={0}
                max={15}
                step={1}
              />
            </div>
          ) : null}

          <div className="flex items-center justify-center ml-2 xl:ml-4 2xl:ml-2">
            <div
              className="w-full h-full flex align-center"
              style={{
                marginRight: showGutter || showRaggedGutter ? "" : "25px",
              }}
            >
              <Dropdown_aspect
                options={
                  isCard ? [{ label: "None", value: "None" }] : options
                }
                value={isCard ? "None" : aspectRatio_FrameSize}
                aspectRatio_FrameSize={
                  isCard ? "None" : aspectRatio_FrameSize
                }
                setAspectRatio_FrameSize={setAspectRatio_FrameSize}
                label={"Ratio"}
                selectedID={isCard ? 0 : selectedID}
                onChange={(value) => {
                  if (isCard) return;
                  getBlockSize("aspectRatio_frame", value);

                  const idx = options.findIndex((opt) => opt.value === value);
                  if (idx !== -1) {
                    setSelectedID(idx);
                  }
                }}
              />
            </div>
          </div>

          {!isCard && (
          <div className="footerBgControls">
            <span className="footerBgControls_label">Background</span>
            <ColorPicker
              id="footer-background-color"
              value={matteColor}
              onChange={handleMatteColorChange}
              onBlur={() => saveProjectSettingsCall()}
              allowTransparent
              showHex
            />
            {!matteIsTransparent && (
              <button
                type="button"
                className="footerBgControls_btn footerBgControls_btnClear"
                onClick={clearMatteColor}
                aria-label="Remove background color"
                title="Remove background color"
              >
                <FiX size={14} />
              </button>
            )}
            {/* <input
              ref={bgFileRef}
              type="file"
              accept="image/png,image/jpeg,image/jpg,image/webp"
              className="footerBgControls_file"
              onChange={handleBackgroundImagePick}
            />
            <button
              type="button"
              className="footerBgControls_btn"
              disabled={isBgUploading}
              onClick={() => bgFileRef.current?.click()}
              aria-label="Upload custom background image"
              title="Upload background image"
            >
              <FiImage size={14} />
              <span>
                {isBgUploading ? "…" : backgroundImage ? "Replace" : "Image"}
              </span>
            </button>
            {backgroundImage ? (
              <button
                type="button"
                className="footerBgControls_btn footerBgControls_btnClear"
                onClick={clearBackgroundImage}
                aria-label="Remove background image"
                title="Remove background image"
              >
                <FiX size={14} />
              </button>
            ) : null}
            {backgroundImage ? (
              <span
                className="footerBgControls_thumb"
                style={{ backgroundImage: `url(${backgroundImage})` }}
                aria-hidden="true"
              />
            ) : null} */}
          </div>
          )}

          {isCard ? (
            ""
          ) : (
            <div
              className=""
              style={{
                display: showGutter || showRaggedGutter ? "" : "none",
              }}
            >
              {/* <span className="h-[20px] border-r-[1px] border-[#2a2740]" /> */}
            </div>
          )}
        </div>

        <div className="rightBottom">
          {!isCard && (
            <div
              className="titleSafeToggle"
              onClick={() => setIsTitleSafe(!isTitleSafe)}
            >
              <span className="titleSafeToggle_label">Title Safe</span>
              <button
                type="button"
                className={`titleSafeToggle_switch ${isTitleSafe ? "is-on" : ""}`}
                aria-pressed={isTitleSafe}
                aria-label="Toggle title-safe guide"
              >
                <span className="titleSafeToggle_knob" />
              </button>
            </div>
          )}

          {isCard && (
            <div
              className="titleSafeToggle"
              onClick={() => setIsDisplayTitle(!isDisplayTitle)}
            >
              <span className="titleSafeToggle_label">Title Safe</span>
              <button
                type="button"
                className={`titleSafeToggle_switch ${isDisplayTitle ? "is-on" : ""}`}
                aria-pressed={isDisplayTitle}
                aria-label="Toggle title display"
              >
                <span className="titleSafeToggle_knob" />
              </button>
            </div>
          )}
          <div className=" flex justify-center items-center "></div>
        </div>

        <CloneProjectModal
          projectCloneModalOpen={projectCloneModalOpen}
          setProjectCloneModalOpen={setProjectCloneModalOpen}
        />
      </div>
    </>
  );
};

export default Footer;
